import { MenuItem, TextField } from '@mui/material'
import { useAccountSummary } from '../../hooks/api/useAccountLedger'

interface PaymentAccountPickerProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

const PaymentAccountPicker = ({ value, onChange, label = 'Paid from / received into' }: PaymentAccountPickerProps) => {
  const { data } = useAccountSummary()
  return (
    <TextField select label={label} value={value} onChange={(event) => onChange(event.target.value)} fullWidth size="small">
      <MenuItem value="cash">Cash in hand</MenuItem>
      {data?.banks.map((bank) => <MenuItem key={bank._id} value={bank._id}>{bank.name}</MenuItem>)}
    </TextField>
  )
}

export default PaymentAccountPicker
